export const environment = {
  production: true,
  master_url: 'https://nuuduu.com',
  master_ws_url: 'ws://127.0.0.1:3333',
  version: '2025-06-21 04:57:09 +0300 448a78f',
  version_hash: '448a78f',
  //locales: ["de", "hr", "nl", "bg", "tr", "ka", "ru", "sr", "en-GB", "cs", "sk", "da", "et", "fi", "fr", "de", "el", "hu", "ga", "it", "lv", "lt", "lb", "mt", "pl", "pt", "ro", "sl", "es", "sv"],
  locales: ["en-GB", "ar", "et", "fi", "lv", "lt", "ru", "sv"],
  public_ordering: true,
  country_selector: true,
  mixpanel_token: '7f098a008f53e450f675bc8d310ce212',
  default_organization_id: 10,
  default_youtube_link: 'https://youtube.com/shorts/TqAxhfuCRGA?feature=share',
  default_youtube_links: {
    'en-GB': 'https://youtube.com/shorts/TqAxhfuCRGA?feature=share',
    'ar': 'https://youtube.com/shorts/TqAxhfuCRGA?feature=share',
    'et': 'https://youtube.com/shorts/TqAxhfuCRGA?feature=share',
    'fi': 'https://youtube.com/shorts/TqAxhfuCRGA?feature=share',
    'lv': 'https://youtube.com/shorts/TqAxhfuCRGA?feature=share',
    'lt': 'https://youtube.com/shorts/TqAxhfuCRGA?feature=share',
    'ru': 'https://youtube.com/shorts/TqAxhfuCRGA?feature=share',
    'sv': 'https://youtube.com/shorts/TqAxhfuCRGA?feature=share',
  },
  default_youtube_channel_link: 'https://www.youtube.com/@NuuduuCOM',
  default_youtube_channel_links: {
    'en-GB': 'https://youtube.com/NuuduuCOM',
    'ar': 'https://youtube.com/NuuduuCOM',
    'et': 'https://youtube.com/NuuduuEE',
    'fi': 'https://youtube.com/NuuduuFI',
    'lv': 'https://youtube.com/NuuduuLV',
    'lt': 'https://youtube.com/NuuduuLT',
    'ru': 'https://youtube.com/NuuduuEE',
    'sv': 'https://youtube.com/NuuduuSE',
  },
  default_facebook_link: 'https://www.facebook.com/NuuduuCOM',
  default_facebook_links: {
    'en-GB': 'https://www.facebook.com/NuuduuCOM',
    'ar': 'https://www.facebook.com/NuuduuSE',
    'et': 'https://www.facebook.com/NuuduuEE',
    'fi': 'https://www.facebook.com/NuuduuFI',
    'lv': 'https://www.facebook.com/NuuduuLatvia',
    'lt': 'https://www.facebook.com/NuuduuLT',
    'ru': 'https://www.facebook.com/NuuduuEE',
    'sv': 'https://www.facebook.com/NuuduuSE',
  },
  default_x_link: 'https://x.com/NuuduuCOM',
  firebaseConfig: {
    apiKey: "AIzaSyC6otbnO_4oaHV1FMFVVGjJKB9xLuGT5zw",
    authDomain: "nuuduu.com",
    projectId: "nuuduu-apps",
    storageBucket: "nuuduu-apps.firebasestorage.app",
    messagingSenderId: "685116462576",
    appId: "1:685116462576:web:3ce31bea4a3020f207b935"
  }
}

